import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'

export default function QuestionsEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Questions to display.
        </h5>
        <div className='my-4'>
          When you have Questions they will appear here. Start by creating some questions.
        </div>
        <Button as={Link} to='/questions/create' variant='outline-primary' className="px-5">
          Create Question
        </Button>
      </Card.Body>
    </Card>
  )
}
